export function formatDate(dateString?: string | Date | null): string {
  if (!dateString) return "-";
  try {
    const date = typeof dateString === "string" ? new Date(dateString) : dateString;
    if (Number.isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat("pt-BR", {
      dateStyle: "short",
      timeStyle: "medium",
    }).format(date);
  } catch {
    return String(dateString);
  }
}

export function formatRelativeTime(dateString?: string | null): string {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "-";
    const now = new Date();
    const diffSec = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffSec < 60) return `${diffSec}s atrás`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m atrás`;
    if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h atrás`;
    return `${Math.floor(diffSec / 86400)}d atrás`;
  } catch {
    return "-";
  }
}

export function getErrorMessage(err: unknown, fallback = "Ocorreu um erro"): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }
  if (typeof err === "string" && err.trim() !== "") {
    return err;
  }
  if (
    err !== null &&
    typeof err === "object" &&
    "message" in err &&
    typeof (err as { message: unknown }).message === "string"
  ) {
    return (err as { message: string }).message;
  }
  return fallback;
}
